/**
 * Areas and projects — the PARA containers (SPEC.md §4).
 *
 * Just the page shell: every section on it is portable (D102's `AreasCard`/`ProjectsCard`,
 * or whatever else a reader has moved here via the unlock-mode dropdown), so this only has
 * to ask `sectionsForPage` what belongs here and render each through the shared registry —
 * the same reduction `Settings.tsx` went through (D110).
 */

import { useCallback, useState } from "react";
import { sectionsForPage, type SectionId } from "../layout/model";
import { renderSection } from "../layout/sectionRegistry";
import { LayoutGrid, type Section } from "../layout/LayoutGrid";

export function Structure() {
  const [revision, setRevision] = useState(0);
  const bump = useCallback(() => setRevision((n) => n + 1), []);

  const sections: Section[] = sectionsForPage("structure")
    .map((id): Section | null => {
      const node = renderSection(id as SectionId, { refreshKey: revision, onChange: bump });
      return node ? { id, node } : null;
    })
    .filter((section): section is Section => section !== null);

  return <LayoutGrid page="structure" sections={sections} onSectionsChanged={bump} />;
}
